import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { computed } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CustomToast',
  props: {
    data: {}
  },
  setup(__props: any) {

const props = __props;

  

    const toastClasses = computed(() => {
        return {
            success: 'text-green-800',
            error: 'text-red-800',
            info: 'text-blue-800',
            default: 'text-gray-800',
        }[props.data.type ?? 'default']
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex items-center gap-3 p-3 rounded-md", toastClasses.value])
  }, [
    _createElementVNode("p", {
      class: "text-sm font-medium",
      innerHTML: props.data.text 
    }, null, 8, _hoisted_1)
  ], 2))
}
}

})